import React from 'react';

import { LocalizedMessage } from 'core/l10n/components';

export interface TermsProps {
    body?: string | null;
    heading?: string | null;
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}

const Terms: React.SFC<TermsProps> = (props) => {
    if (!props.body) {
        return null;
    }

    return (
        <div>
            <div className="small">
                {props.heading && (
                    <p className="fw-bold" style={{ whiteSpace: 'pre-wrap' }}>
                        {props.heading}
                    </p>
                )}
                <div className="scrollable scrollable--max-short">
                    <p style={{ whiteSpace: 'pre-wrap' }}>{props.body}</p>
                </div>
            </div>
            <div className="text-end pt-2 form-check">
                <label className="form-label">
                    <input {...props.inputProps} type="checkbox" className="form-check-input" />
                    <LocalizedMessage id="claimDetail_label_acceptTermsAndConditions" />
                    <span className="invalid-feedback">
                        <LocalizedMessage id="claimDetail_errorMessage_mustAcceptTermsAndConditions" />
                    </span>
                </label>
            </div>
        </div>
    );
};

export default Terms;
